


import { useEffect } from "react";
import { BtnUploadFileGeneral } from "./BtnUploadFileGeneral";
import { IoReceiptOutline } from 'react-icons/io5';
import { Button } from "primereact/button";


export const BtnUploadFile = ({ files, setFiles, name, typePerson, show, errors, deleteFileInTheList, addNewFileInTheList }) => {

    const handleButtonClick = (index) => {
        if (files[index].ref.current) {
            files[index].isCharged = files[index].file?.name ? true : !files[index].isCharged;
            files[index].charged = files[index].file?.name || files[index].isCharged ? 'Cargado' : 'Cargar';
            files[index].ref.current.click();
        } else {
            console.error(`Referencia al input ${index} no encontrada.`);
        }
    };


    const handleFileChange = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            // Definir el tamaño máximo permitido (10 MB en este caso)
            const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB en bytes

            // Verificar el tipo de archivo (aceptar PDFs e imágenes)
            const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!validTypes.includes(file.type)) {
                show('error', 'El archivo seleccionado no es un PDF ni una imagen válida.', 'Error');
                return;
            }

            // Verificar el tamaño del archivo
            if (file.size > MAX_FILE_SIZE) {
                show('error', `El archivo es demasiado grande. El tamaño máximo es 6 MB.`, 'Error');
                return;
            }

            // Verificar si el archivo ya existe por nombre
            const fileExists = files.some(item => item.file && item.file.name === file.name);
            if (fileExists) {
                show('error', 'Ya existe un archivo con el mismo nombre.', 'Error');
                return;
            }

            const previewUrl = URL.createObjectURL(file);
            const updatedFiles = files.map((item, i) =>
                i === index ? { ...item, file, previewUrl } : item
            );

            // Comprobar si el archivo ha sido cargado correctamente antes de actualizar el estado
            if (file && file.size > 0) {
                setFiles(prev => ({
                    ...prev,
                    [name]: updatedFiles
                }));
                updatedFiles[index].isCharged = true;

                show('success', 'Archivo cargado correctamente.', 'Éxito');
            } else {
                console.error('Hubo un problema al cargar el archivo.');
                show('error', 'Hubo un problema al cargar el archivo.', 'Error');
            }
        }


    };

    useEffect(() => {
        return () => {
            files.forEach(fileData => {
                if (fileData.previewUrl) {
                    URL.revokeObjectURL(fileData.previewUrl);
                }
            });
        };
    }, [files]);

    return (
        <div className="col col-md w-full">
            <div className="container-btn row m-w-[900px]" style={{
                maxWidth: '900px',
                margin: 'auto',
            }}>
                <div className="TopText2 pt-4 w-full flex flex-row items-center justify-center m-auto flex-wrap">
                    <BtnUploadFileGeneral
                        files={files}
                        handleFileChange={handleFileChange}
                        handleButtonClick={handleButtonClick}
                        typePerson={typePerson}
                        errors={errors}
                        name={name}
                        deleteFileInTheList={deleteFileInTheList}
                    />
                </div>
                <Button
                    type="button"
                    icon={<IoReceiptOutline size={23} />}
                    outlined={true}
                    style={{
                        maxHeight: '70px',
                        height: '10%',
                        margin: 'auto',
                        width: '100% !important',
                    }}
                    className={` no-upload-add Receip py-3 w-full`}
                    label={'agrega otro'}
                    onClick={() => addNewFileInTheList(name, name + "_extra")}
                />
            </div>
        </div>
    );
};
